import { Alert } from "@mantine/core";
import { WhiteboardPermission } from "@src/gql/graphql";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { fetchActiveWhiteboardQueryOptions } from "../board/queries/fetch-active-whiteboard";
import type { WhiteboardDocumentId } from "../collaboration/document-id";
import { LoadingSpinner } from "../loading-spinner";
import { ShareWhiteboardPanelContent } from "./share-whiteboard-panel-content";

type ShareWhiteboardPanelModalProps = {
	whiteboardId: WhiteboardDocumentId;
};

export function ShareWhiteboardPanelModal({
	whiteboardId,
}: ShareWhiteboardPanelModalProps) {
	const whiteboardQueryOptions = useMemo(
		() => fetchActiveWhiteboardQueryOptions(whiteboardId, null),
		[whiteboardId],
	);

	const { data: sharePanelWhiteboard, isLoading } = useQuery(
		whiteboardQueryOptions,
	);

	if (isLoading) {
		return (
			<div className="flex justify-center items-center h-full min-h-[200px]">
				<LoadingSpinner />
			</div>
		);
	}

	if (!sharePanelWhiteboard) {
		return (
			<Alert color="red" title="Error">
				No whiteboard is currently active. Please select a whiteboard first.
			</Alert>
		);
	}

	if (sharePanelWhiteboard.permission !== WhiteboardPermission.Owner) {
		return (
			<Alert color="blue" title="Information">
				You cannot share whiteboards that were shared with you.
			</Alert>
		);
	}

	return <ShareWhiteboardPanelContent whiteboard={sharePanelWhiteboard} />;
}
